import Modal from '@/containers/Modals/Modal';
import Item from './Item';
import { useAppCommon } from '@/hooks';
import { mapGetters } from 'vuex';
import { getPageIdsOfSheet } from '@/common/utils';
import { GETTERS as PRINT_GETTERS } from '@/store/modules/print/const';
export default {
  components: {
    Modal,
    Item
  },
  setup() {
    const { isDigitalEdition: isDigital, generalInfo } = useAppCommon();
    return {
      isDigital,
      generalInfo
    };
  },
  computed: {
    ...mapGetters({
      pageSelected: PRINT_GETTERS.CURRENT_SHEET
    }),
    bookId() {
      return this.generalInfo?.bookId;
    },
    isShowInfoPage() {
      return !this.isDigital && this.pageSelected?.id; //Show Info Page in print Edition and select 1 sheet
    },
    pageIds() {
      if (this.isShowInfoPage) {
        const [leftPageId, rightPageId] = getPageIdsOfSheet(
          this.pageSelected?.pageIds,
          this.pageSelected?.type
        );
        return {
          leftPageId,
          rightPageId
        };
      }
    }
  }
};
